import React, { useState } from 'react';
import './FAQComponent.css';

const FAQComponent = () => {
  const [faqOpen, setFaqOpen] = useState([false, false, false, false, false, false]);

  const toggleFaq = (index) => {
    setFaqOpen(faqOpen.map((isOpen, i) => (i === index ? !isOpen : isOpen)));
  };

  return (
    <div className="faq-section-pricing">
      <h1>Frequently Asked Questions</h1>

      <div className="faq-item" onClick={() => toggleFaq(0)}>
        <h3>
          Can I use Bumpups for free?
          <span className={faqOpen[0] ? "caret rotate" : "caret"}>⌄</span>
        </h3>
        <div className={faqOpen[0] ? "faq-content show" : "faq-content"}>
          <b>Yes</b>, Bumpups offers a free plan with 60 minutes of video processing each month. <br /><br />
          You can use it without entering any payment information.
        </div>
      </div>

      <div className="faq-item" onClick={() => toggleFaq(1)}>
        <h3>
          Which languages are supported?
          <span className={faqOpen[1] ? "caret rotate" : "caret"}>⌄</span>
        </h3>
        <div className={faqOpen[1] ? "faq-content show" : "faq-content"}>
          <p>Select your preferred language for video processing:</p>
          <ul>
            <li><strong>English</strong> (en)</li>
            <li><strong>Hindi</strong> (hi)</li>
            <li><strong>Spanish</strong> (es)</li>
            <li><strong>Portuguese</strong> (pt)</li>
            <li><strong>Russian</strong> (ru)</li>
            <li><strong>German</strong> (de)</li>
            <li><strong>French</strong> (fr)</li>
            <li><strong>Japanese</strong> (ja)</li>
            <li><strong>Korean</strong> (ko)</li>
            <li><strong>Arabic</strong> (ar)</li>
          </ul>
        </div>
      </div>

      <div className="faq-item" onClick={() => toggleFaq(2)}>
        <h3>
          What video durations can the platform support?
          <span className={faqOpen[2] ? "caret rotate" : "caret"}>⌄</span>
        </h3>
        <div className={faqOpen[2] ? "faq-content show" : "faq-content"}>
          <p>Here’s an overview of the video lengths you can process:</p>
          <ul>
            <li><strong>Minimum duration:</strong> 4 minutes</li>
            <li><strong>Free plan max:</strong> 60 minutes per video</li>
            <li><strong>Pro plan max:</strong> 3.5 hours per video</li>
          </ul>
          <p>We’re working on adding more length options soon.</p>
        </div>
      </div>

      <div className="faq-item" onClick={() => toggleFaq(3)}>
        <h3>
          Can I upload local video files?
          <span className={faqOpen[3] ? "caret rotate" : "caret"}>⌄</span>
        </h3>
        <div className={faqOpen[3] ? "faq-content show" : "faq-content"}>
          <p><strong>Yes</strong>—local file uploads are available exclusively on the Pro plan. Upgrade from the Free plan to access this feature.</p> <br />
          <p>Local uploads leverage our specialized <strong>Bump-1.0</strong> model for advanced vision context, delivering more accurate scene analysis and frame-by-frame insights.</p>
        </div>
      </div>

      <div className="faq-item" onClick={() => toggleFaq(4)}>
        <h3>
          Does Bumpups have an API for developers?
          <span className={faqOpen[4] ? "caret rotate" : "caret"}>⌄</span>
        </h3>
        <div className={faqOpen[4] ? "faq-content show" : "faq-content"}>
          <p>Yes—see the <a href="https://docs.bumpups.com/docs/getting-started" target="_blank" rel="noopener noreferrer">API Docs</a>.</p> <br />
          <p>Provides RESTful endpoints for summaries, timestamps, and interactive queries. More integrations (Google Drive, Zoom) coming soon.</p>
        </div>
      </div>


      <div className="faq-item" onClick={() => toggleFaq(5)}>
        <h3>
          How do I learn more about Bumpups?
          <span className={faqOpen[5] ? "caret rotate" : "caret"}>⌄</span>
        </h3>
        <div className={faqOpen[5] ? "faq-content show" : "faq-content"}>
          <p>
            Learn more on our <a href="https://intercom.help/bumpups/en/" target="_blank" rel="noopener noreferrer">Help Center</a>.
          </p>
        </div>
      </div>


    </div>
  );
};

export default FAQComponent;
